import { AuthenticatedRoute, UnauthenticatedRoute } from 'components/Route';
import React from 'react';
import { Switch } from 'react-router';
import ScrollToTop from 'utilities/ScrollToTop';
import StoreContextWrapper from 'utilities/StoreContextWrapper';
import Activities from './Activities/Activities';
import Contact from './Contact/Contact';
import Dashboard from './Dashboard/Dashboard';
import Group from './Group/Group';
import Home from './Home/Home';
import Page from './Page/Page';
import Vacancies from './Vacancies/Vacancies';
import Quiz from './Quiz/Quiz';
import Schools from './Schools/Schools';

export default function Routes() {
    return (
        <StoreContextWrapper>
            <ScrollToTop />
            <Switch>
                <UnauthenticatedRoute path="/" exact component={Home} />
                <UnauthenticatedRoute path="/home" component={Home} />
                <UnauthenticatedRoute path="/contact" component={Contact} />
                <UnauthenticatedRoute
                    path="/onze-scholen"
                    component={Schools}
                />
                <UnauthenticatedRoute path="/vacatures" component={Vacancies} />
                <UnauthenticatedRoute
                    path="/activiteiten"
                    component={Activities}
                />
                <UnauthenticatedRoute path="/page" component={Page} />
                <UnauthenticatedRoute path="/test" component={Quiz} />
                <AuthenticatedRoute path="/dashboard" component={Dashboard} />
                <AuthenticatedRoute path="/group/:id" component={Group} />
                <UnauthenticatedRoute path="/:slug" component={Page} />
            </Switch>
        </StoreContextWrapper>
    );
}
